"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _assertThisInitialized = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DebounceTableSearch = void 0;
exports.debounceSearchRender = debounceSearchRender;
var _react = _interopRequireWildcard(require("react"));
var _Grow = _interopRequireDefault(require("@material-ui/core/Grow"));
var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));
var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Clear = _interopRequireDefault(require("@material-ui/icons/Clear"));
var _styles = require("@material-ui/core/styles");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this;
    var args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
var defaultStyles = function defaultStyles(theme) {
  return {
    main: {
      display: 'flex',
      flex: '1 0 auto'
    },
    searchIcon: {
      color: theme.palette.text.secondary,
      marginTop: '10px',
      marginRight: '8px'
    },
    searchText: {
      flex: '0.8 0'
    },
    clearIcon: {
      '&:hover': {
        color: theme.palette.error.main
      }
    }
  };
};
var _DebounceTableSearch = /*#__PURE__*/function (_react$default$Compon) {
  _inherits(_DebounceTableSearch, _react$default$Compon);
  function _DebounceTableSearch() {
    var _this;
    _classCallCheck(this, _DebounceTableSearch);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(_DebounceTableSearch).apply(this, arguments));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleTextChangeWrapper", function (debouncedSearch) {
      return function (event) {
        debouncedSearch(event.target.value);
      };
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onKeyDown", function (event) {
      if (event.keyCode === 27) {
        _this.props.onHide();
      }
    });
    return _this;
  }
  _createClass(_DebounceTableSearch, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keydown', this.onKeyDown, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.onKeyDown, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        options = _this$props.options,
        onHide = _this$props.onHide,
        searchText = _this$props.searchText,
        debounceWait = _this$props.debounceWait;
      var debouncedSearch = debounce(function (value) {
        _this2.props.onSearch(value);
      }, debounceWait);
      return /*#__PURE__*/_react.default.createElement(_Grow.default, {
        appear: true,
        in: true,
        timeout: 300
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: classes.main
      }, /*#__PURE__*/_react.default.createElement(_Search.default, {
        className: classes.searchIcon
      }), /*#__PURE__*/_react.default.createElement(_TextField.default, _extends({
        className: classes.searchText,
        autoFocus: true,
        InputProps: {
          'data-test-id': options.textLabels.toolbar.search,
          'aria-label': options.textLabels.toolbar.search
        },
        defaultValue: searchText,
        onChange: this.handleTextChangeWrapper(debouncedSearch),
        fullWidth: true,
        inputRef: function inputRef(el) {
          return _this2.searchField = el;
        },
        placeholder: options.searchPlaceholder
      }, options.searchProps ? options.searchProps : {})), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
        className: classes.clearIcon,
        onClick: onHide
      }, /*#__PURE__*/_react.default.createElement(_Clear.default, null))));
    }
  }]);
  return _DebounceTableSearch;
}(_react.default.Component);
var DebounceTableSearch = (0, _styles.withStyles)(defaultStyles, {
  name: 'MUIDataTableSearch'
})(_DebounceTableSearch);
exports.DebounceTableSearch = DebounceTableSearch;
function debounceSearchRender() {
  var debounceWait = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 200;
  return function (searchText, handleSearch, hideSearch, options) {
    return /*#__PURE__*/_react.default.createElement(DebounceTableSearch, {
      searchText: searchText,
      onSearch: handleSearch,
      onHide: hideSearch,
      options: options,
      debounceWait: debounceWait
    });
  };
}